import PropTypes from 'prop-types';
import { memo, useCallback, useEffect, useRef } from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'SelectPositionObserver';
const getDefaultPosition = (observationTarget)=>{
    if (observationTarget) {
        const { top, left } = observationTarget.getBoundingClientRect();
        return {
            top,
            left
        };
    }
    return {
        top: 0,
        left: 0
    };
};
const SelectPositionObserver = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, scheduleUpdate, observationTarget, positionObserverInterval = 250, observePositionChanges, isOpen, update } = props;
    const interval = useRef(null);
    const previousPosition = useRef(getDefaultPosition(observationTarget));
    const clearRunningInterval = useCallback(()=>{
        if (interval.current) {
            clearInterval(interval.current);
        }
    }, []);
    useEffect(()=>{
        if (isOpen) {
            update?.();
        }
    }, [
        update,
        isOpen
    ]);
    useEffect(()=>{
        clearRunningInterval();
        if (observationTarget && observePositionChanges && isOpen) {
            interval.current = setInterval(()=>{
                const { top, left } = observationTarget.getBoundingClientRect();
                const { left: previousLeft, top: previousTop } = previousPosition.current;
                if (previousLeft !== left || previousTop !== top) {
                    previousPosition.current = {
                        top,
                        left
                    };
                    scheduleUpdate?.();
                }
            }, positionObserverInterval);
        }
        return ()=>{
            clearRunningInterval();
        };
    }, [
        observationTarget,
        positionObserverInterval,
        scheduleUpdate,
        clearRunningInterval,
        observePositionChanges,
        isOpen
    ]);
    return children;
};
SelectPositionObserver.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    observationTarget: PropTypes.object,
    observePositionChanges: PropTypes.bool,
    positionObserverInterval: PropTypes.number,
    scheduleUpdate: PropTypes.func,
    update: PropTypes.func
};
export default /*#__PURE__*/ memo(SelectPositionObserver);
